import { render, staticRenderFns } from "./cert-data.vue?vue&type=template&id=30cc229b&"
import script from "./cert-data.vue?vue&type=script&lang=js&"
export * from "./cert-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports